import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;
import { InvestorService } from 'src/app/services/investor.service';
import * as _ from 'lodash';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
@Component({
  selector: 'app-investor',
  templateUrl: './investor.component.html',
  styleUrls: ['./investor.component.css']
})
export class InvestorComponent implements OnInit {

  investorComplaintForm: FormGroup;
  restrictTabflag = true;
  editParticularId: any;
  editParticularData: any;
  dateOfInterimReplyIfAnyModel: any;
  dateOnWhichComplaintWasFullySatisfiedModel: any;
  rocModel: any;
  stockExchangeModel: any;
  sebiModel: any;
  dateOfOtherRegulatoryModel: any;
  dateOfReceiptOfComplaintModel: any;
  TodayDate: NgbDateStruct;
  disabledOnclick: boolean;

  constructor(private InvestorService: InvestorService,
    private activatedRoute: ActivatedRoute,
    private commonFunction: CommonFunction,
    private alert: AlertComponent,
    private router: Router) { }

  ngOnInit() {
    this.investorComplaintForm = new FormGroup({
      dateOfReceiptOfComplaint: new FormControl('', [Validators.required]),
      natureOfComplaint: new FormControl('', []),
      nameOfThePersonLodgingTheComplaint: new FormControl('', [Validators.pattern("^[a-zA-Z' ]*$")]),
      depositReceiptNumber: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ]*$")]),
      folioNumber: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      clientIdNumber: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ]*$")]),
      dateOfInterimReplyIfAny: new FormControl('', []),
      dateOnWhichComplaintWasFullySatisfied: new FormControl('', []),
      timeTakenForResolvingComplaints: new FormControl('', []),
      roc: new FormControl('', []),
      stockExchange: new FormControl('', []),
      sebi: new FormControl('', []),
      nameOfRegulatory: new FormControl('', [Validators.pattern("^[a-zA-Z' ]*$")]),
      dateOfOtherRegulatory: new FormControl('', []),
      remarks: new FormControl('', []),
    });

    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.restrictTabflag = true;
        this.editParticularId = params['particularId'];
        this.getInvestorComplaintsById(this.editParticularId);
      } else {
        this.restrictTabflag = false;
      }
    })

    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    this.TodayDate = { year: year, month: month, day: day };
  }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['masterinvestorcomplaints']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + '-' + date.day + '-' + date.year;
    }
    return null;
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  investorEntry() {
    this.disabledOnclick = true;
    var investorObject = {
      dateOfReceiptOfComplaint: this.setDate(this.investorComplaintForm.controls.dateOfReceiptOfComplaint.value),
      natureOfComplaint: this.investorComplaintForm.controls.natureOfComplaint.value,
      nameOfThePersonLodgingTheComplaint: this.investorComplaintForm.controls.nameOfThePersonLodgingTheComplaint.value,
      depositReceiptNumber: this.investorComplaintForm.controls.depositReceiptNumber.value,
      folioNumber: this.investorComplaintForm.controls.folioNumber.value,
      clientIdNumber: this.investorComplaintForm.controls.clientIdNumber.value,
      dateOfInterimReplyIfAny: this.setDate(this.investorComplaintForm.controls.dateOfInterimReplyIfAny.value),
      dateOnWhichComplaintWasFullySatisfied: this.setDate(this.investorComplaintForm.controls.dateOnWhichComplaintWasFullySatisfied.value),
      timeTakenForResolvingComplaints: this.investorComplaintForm.controls.timeTakenForResolvingComplaints.value,
      roc: this.setDate(this.investorComplaintForm.controls.roc.value),
      stockExchange: this.setDate(this.investorComplaintForm.controls.stockExchange.value),
      sebi: this.setDate(this.investorComplaintForm.controls.sebi.value),
      nameOfRegulatory: this.investorComplaintForm.controls.nameOfRegulatory.value,
      dateOfOtherRegulatory: this.setDate(this.investorComplaintForm.controls.dateOfOtherRegulatory.value),
      remarks: this.investorComplaintForm.controls.remarks.value,
    }

    this.InvestorService.investorComplaint(investorObject).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        //this.alert.successWithOk("Details added successfully.", '/investorComplaints/edit/' + response.data._id);
        this.alert.successWithOk(response.message, 'masterinvestorcomplaints');
      } else {
        // this.alert.error(" ooop! something went wrong");
        if(response.err_fields){
        this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }
        else{
          this.alert.error(" ooop! something went wrong");
        }
      }

    })
    // this.InvestorService.investorComplaint(investorObject).subscribe(response => {
    // })
  }

  getInvestorComplaintsById(particularId) {
    this.InvestorService.updateinvestor(particularId).subscribe(response => {
      this.editParticularData = response.data[0];
      //this.investorComplaintForm.controls.dateOfReceiptOfComplaint.setValue(this.editParticularData.dateOfReceiptOfComplaint);
      this.investorComplaintForm.controls.natureOfComplaint.setValue(this.editParticularData.natureOfComplaint);
      this.investorComplaintForm.controls.nameOfThePersonLodgingTheComplaint.setValue(this.editParticularData.nameOfThePersonLodgingTheComplaint);
      this.investorComplaintForm.controls.depositReceiptNumber.setValue(this.editParticularData.depositReceiptNumber);
      this.investorComplaintForm.controls.folioNumber.setValue(this.editParticularData.folioNumber);
      this.investorComplaintForm.controls.clientIdNumber.setValue(this.editParticularData.clientIdNumber);
      this.investorComplaintForm.controls.nameOfRegulatory.setValue(this.editParticularData.nameOfRegulatory);
      //this.investorComplaintForm.controls.dateOfInterimReplyIfAny.setValue(this.editParticularData.dateOfInterimReplyIfAny);
      //this.investorComplaintForm.controls.dateOnWhichComplaintWasFullySatisfied.setValue(this.editParticularData.dateOnWhichComplaintWasFullySatisfied);
      this.investorComplaintForm.controls.timeTakenForResolvingComplaints.setValue(this.editParticularData.timeTakenForResolvingComplaints);
      //this.investorComplaintForm.controls.roc.setValue(this.editParticularData.yesdateofpassingresolution);
      // this.investorComplaintForm.controls.stockExchange.setValue(this.editParticularData.stockExchange);
      //this.investorComplaintForm.controls.sebi.setValue(this.editParticularData.sebi);
      //this.investorComplaintForm.controls.dateOfOtherRegulatory.setValue(this.editParticularData.dateOfOtherRegulatory);
      this.investorComplaintForm.controls.remarks.setValue(this.editParticularData.remarks);

      if (this.editParticularData.dateOfReceiptOfComplaint != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfReceiptOfComplaint));
        this.dateOfReceiptOfComplaintModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateOfInterimReplyIfAny != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfInterimReplyIfAny));
        this.dateOfInterimReplyIfAnyModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateOnWhichComplaintWasFullySatisfied != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOnWhichComplaintWasFullySatisfied));
        this.dateOnWhichComplaintWasFullySatisfiedModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.roc != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.roc));
        this.rocModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.stockExchange != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.stockExchange));
        this.stockExchangeModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.sebi != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.sebi));
        this.sebiModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateOfOtherRegulatory != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfOtherRegulatory));
        this.dateOfOtherRegulatoryModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
    })
  }

  updateInvestorComplaints() {
    this.disabledOnclick = true;
    console.log("investorComplaintForm ",this.investorComplaintForm);
    var object = {
      dateOfReceiptOfComplaint: this.setDate(this.investorComplaintForm.controls.dateOfReceiptOfComplaint.value),
      natureOfComplaint: this.investorComplaintForm.controls.natureOfComplaint.value,
      nameOfThePersonLodgingTheComplaint: this.investorComplaintForm.controls.nameOfThePersonLodgingTheComplaint.value,
      depositReceiptNumber: this.investorComplaintForm.controls.depositReceiptNumber.value,
      folioNumber: this.investorComplaintForm.controls.folioNumber.value,
      clientIdNumber: this.investorComplaintForm.controls.clientIdNumber.value,
      dateOfInterimReplyIfAny: this.setDate(this.investorComplaintForm.controls.dateOfInterimReplyIfAny.value),
      dateOnWhichComplaintWasFullySatisfied: this.setDate(this.investorComplaintForm.controls.dateOnWhichComplaintWasFullySatisfied.value),
      timeTakenForResolvingComplaints: this.investorComplaintForm.controls.timeTakenForResolvingComplaints.value,
      roc: this.setDate(this.investorComplaintForm.controls.roc.value),
      stockExchange: this.setDate(this.investorComplaintForm.controls.stockExchange.value),
      sebi: this.setDate(this.investorComplaintForm.controls.sebi.value),
      nameOfRegulatory: this.investorComplaintForm.controls.nameOfRegulatory.value,
      dateOfOtherRegulatory: this.setDate(this.investorComplaintForm.controls.dateOfOtherRegulatory.value),
      remarks: this.investorComplaintForm.controls.remarks.value
    }

    this.InvestorService.updateInvestorComplaints(object, this.editParticularId).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        //this.alert.success("Details updated successfully.");
        this.alert.successWithOk(response.message, 'masterinvestorcomplaints');
      } else {
        // this.alert.error(" ooop! something went wrong");
        if(response.err_fields){
        this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }
        else{
          this.alert.error(" ooop! something went wrong");
        }
      }

    })
  }
  generateOutput() {
    var object = {
      id: this.editParticularId,
      fromDate: null,
      toDate: null,
      name: null
    }
    this.InvestorService.generateInvestorDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editParticularId);
          setTimeout(function () {
            self.downloadPdfDocument(self.editParticularId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.InvestorService.downloadInvestorFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.InvestorService.downloadInvestorPdfFile(id, 'Single');
  }
}

